import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzRadioModule } from 'ng-zorro-antd/radio';

import { TtcButtonSharedModule } from '@libs/src/ttc-button-shared/ttc-button-shared.module';
import { FindPipeModule } from '@main-client/src/app/pipes/find-pipe/find-pipe.module';
import { GetCustomRoleFromProgramRolesPipeModule } from '@main-client/src/app/pipes/get-custom-role-from-program-roles/get-custom-role-from-program-roles-pipe.module';
import { ProgramParticipantPreferencesModule } from '@main-client/src/app/program-participant-preferences/program-participant-preferences.module';

import { UserOnboardingProgramFormComponent } from './user-onboarding-program-form.component';

import { LiveTranslateModule } from '../../pipes/live-translate/live-translate.module';

@NgModule({
  declarations: [UserOnboardingProgramFormComponent],
  exports: [UserOnboardingProgramFormComponent],
  imports: [
    CommonModule,
    FindPipeModule,
    FlexLayoutModule,
    GetCustomRoleFromProgramRolesPipeModule,
    LiveTranslateModule,
    NzFormModule,
    NzIconModule,
    NzInputModule,
    NzInputNumberModule,
    NzRadioModule,
    ProgramParticipantPreferencesModule,
    ReactiveFormsModule,
    RouterModule,
    TtcButtonSharedModule,
  ],
})
export class UserOnboardingProgramFormModule {}
